import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import ClientDashboardPage from '../pages/client/ClientDashboardPage';
import ModifyBookingPage from '../pages/client/ModifyBookingPage';
import AllBookingsPage from '../pages/client/AllBookingsPage';
import PaymentHistoryPage from '../pages/client/PaymentHistoryPage';
import RateMyStayPage from '../pages/client/RateMyStayPage';

export const ClientRoutes = [
  <Route 
    key="client-dashboard" 
    path="/client/dashboard" 
    element={
      <ProtectedRoute requiredRole="client">
        <ClientDashboardPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="client-profile" 
    path="/client/profile" 
    element={
      <ProtectedRoute requiredRole="client">
        <div>Client Profile</div>
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="client-bookings" 
    path="/client/bookings" 
    element={
      <ProtectedRoute requiredRole="client">
        <div>Client Bookings</div>
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="client-booking-details" 
    path="/client/bookings/:bookingId" 
    element={
      <ProtectedRoute requiredRole="client">
        <div>Booking Details</div>
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="client-payments" 
    path="/client/payments" 
    element={
      <ProtectedRoute requiredRole="client">
        <div>Payment History</div>
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="client-settings" 
    path="/client/settings" 
    element={
      <ProtectedRoute requiredRole="client">
        <div>Client Settings</div>
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="client-modify-booking" 
    path="/client/modify-booking/:bookingId" 
    element={
      <ProtectedRoute requiredRole="client">
        <ModifyBookingPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="all-bookings" 
    path="/client/all-bookings" 
    element={
      <ProtectedRoute requiredRole="client">
       <AllBookingsPage/>
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="payment-history" 
    path="/client/payment-history" 
    element={
      <ProtectedRoute requiredRole="client">
       <PaymentHistoryPage /> 
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="rate-my-stay" 
    path="/client/rate-my-stay" 
    element={
      <ProtectedRoute requiredRole="client">
       <RateMyStayPage /> 
      </ProtectedRoute>
    } 
  />
  
]; 